import * as angular from "angular";
import {IController, IScope} from "angular";

export class depotsTableRowCtrl implements IController {

  depotId: any;
  enableDefault: any;
  isDefault: any;

  /* @ngInject */
  constructor(private $depots, private $scope: IScope) {

  }

  $onInit() {
    if (this.depotId) {
      this.$depots(this.depotId).$bindCtrlToId(this.$scope, this, 'depot', 'depotId');
    }
  }

  $onChanges(changes) {
    if (changes.depotId && !changes.depotId.isFirstChange()) {
      this.$onInit();
    }
  };


}

angular
  .module('bringoz.admin.depots')
  .component('depotsTableRow', {
    require: {
      depotsTableCtrl: '^depotsTable'
    },
    bindings: {
      depotId: '<',
      enableDefault: '<?',
      isDefault: '<?'
    },
    template: require('./depots-table-row.html').default,
    controller: depotsTableRowCtrl
  });
